<template>
	<v-app class="auth-layout-wrapper">
		<v-alert
			v-if="isShowAlert"
			absolute
			:type="alertType || 'success'"
			transition="scale-transition"
			class="app-alert"
			:dismissible="false"
		>
			{{ alertMessage }}
			<v-icon style="font-size: 20px" @click="closeAlert">mdi-window-close</v-icon>
		</v-alert>

		<AppTopBar v-bind:menuList="menuList" />

		<v-main class="v-main_container">
			<v-container
				style="padding: 0 !important"
				:fluid="true"
				:class="shouldBeFullWidth ? '' : 'auth-container'"
			>
				<ChatNotification
					v-if="notifications.length > 0 && shouldShowNotification"
					:showChatNotification="showChatNotification"
					:notifications="notifications"
					@closeChatNotification="handleClose"
				/>
				<PostReportNotification :showNotification.sync="showNotification" />
				<v-row
					tag="transition-group"
					name="layout"
					style="flex-wrap: unset; margin: 0; display: flex; justify-content: center"
					:class="{ column__wrapper: true, 'column__wrapper-playerOn': currentPodcast }"
				>
					<div v-if="shouldShowSidebar" class="v-main_container__left" key="sidebar">
						<AppSidebar :menuListHandler="menuListHandler" />
					</div>

					<div :style="{
            justifyContent: isSurvey ? 'center' : 'flex-start',
            padding: isSurvey ? '0' : '0px 20px 0 100px'
          }" class="v-main_container__right" key="main">
						<div class="v-main_container__right__content">
							<slot></slot>
						</div>
					</div>
				</v-row>
			</v-container>

			<transition name="player">
				<AppPlayer v-if="currentPodcast" />
			</transition>
		</v-main>
	</v-app>
</template>

<script>
import { isUndefined } from 'lodash'
import AppSidebar from '@/components/Layouts/parts/AppSidebar'
import AppTopBar from '@/components/Layouts/parts/AppTopBar'
import AppPlayer from '@/components/Layouts/parts/AppPlayer'
import ChatNotification from '@/components/Notifications/ChatNotification'
import PostReportNotification from '@/components/Notifications/PostReportNotification'
import { mapActions, mapGetters } from 'vuex'
import AdBanner from '@/components/Layouts/parts/AdBanner.vue'

export default {
	components: {
		AdBanner,
		AppTopBar,
		AppSidebar,
		AppPlayer,
		ChatNotification,
		PostReportNotification,
	},
	data: () => ({
		navCategory: null,
		showNotification: false,
		showChatNotification: false,
		accentColor: '#9b1045',
		menuList: [],
		notifications: [],
		leftPercent: 23,
		pixelRatio: 1,
	}),
	watch: {
		isAuthenticated(val, oldVal) {
			if (isUndefined(oldVal)) return
			if (!val) this.$router.replace('/auth')
		},
	},
	methods: {
		...mapActions('app', ['hideAlert']),

		closeAlert() {
			clearTimeout(this.closeTimeout)
			this.hideAlert()
		},

		handleClose() {
			this.notifications = []
			this.showChatNotification = false
		},
		menuListHandler(menu) {
			this.menuList = menu
		},
		updateLeftPercent() {
			const zoom = window.innerWidth / window.screen.width
			this.pixelRatio = zoom
			this.leftPercent = Math.min(23 + (zoom - 1) * 30, 40)
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('app', ['isShowAlert', 'alertMessage', 'closeTimeout', 'alertType']),
		...mapGetters('rss', ['currentPodcast']),
    ...mapGetters('event',['survey']),
    isSurvey() {
      return this.$route.query.type === 'quiz' && this.$route.name === 'survey'
    },
    user() {
			return this.profile
		},
		shouldShowNotification() {
			return this.$route.name !== 'chat' && this.$route.name !== 'chats'
		},
		shouldShowSidebar() {
			return this.$route.meta.sidebar && this.$vuetify.breakpoint.width >= 920
		},
		shouldBeFullWidth() {
			return this.$route.meta.fullWidth
		},
	},
	mounted() {
		window.addEventListener('resize', this.updateLeftPercent)
		this.updateLeftPercent()
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateLeftPercent)
	},
	destroyed() {
		this.$eventBus.$off('show-report-notification')

		if (this.user) {
			window.Echo.leave('App.User.' + this.profile.id)
		}
	},
}
</script>

<style lang="scss">
.v-main_container {
	display: flex;
	transition: padding 0.3s ease;
  white-space: pre-line;


	@media (max-width: 919px) {
		background: #f2f2f2;
		padding: 0 20px 0 20px !important;
	}

	&__right {
		width: 65%;
		background-color: #f2f2f2;
		position: relative;
    display: flex;

		&__content {
			max-width: 555px;
			width: 100%;
		}

		@media (max-width: 919px) {
			padding: 0!important;
			width: 100%;
			justify-content: center!important;
		}
	}

	&__left {
		width: 35%;
		display: flex;
		justify-content: flex-end;
		border-right: 1px solid #e2e2e2;
		background-color: #ffffff;
		padding-left: 20px;
		min-height: 100vh;
	}
}

.column {
	&__wrapper {
		&-playerOn {
			margin-bottom: 100px;
			@media (max-width: 710px) {
				margin-bottom: 150px;
			}
			@media (max-width: 530px) {
				margin-bottom: 200px;
			}
		}
	}
}

.app-alert {
	top: 20px;
	right: 20px;
	position: fixed;
	z-index: 999;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.player-enter-active,
.player-leave-active {
	transition: transform 0.3s;
}
.player-enter,
.player-leave-to {
	transform: translateY(100px);
}

.layout-enter-active,
.layout-leave-active {
	transition: all 0.3s ease;
}
.layout-enter,
.layout-leave-to {
	opacity: 0;
	transform: translateX(-20px);
}
.layout-move {
	transition: transform 0.3s ease;
}
</style>
